import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";

function CustomScaleControl() {
  const map = useMap();

  useEffect(() => {
    const fixedScale = L.control.scale({
      metric: true, // metros/km
      imperial: true, // milhas/pés
      maxWidth: 200,
      position: "bottomleft",
    });

    fixedScale.addTo(map);

    return () => {
      fixedScale.remove();
    };
  }, [map]);

  return null;
}

export default CustomScaleControl;
